import { useList, useDetail, useCreate, usePartialUpdate, useDelete, useListInfinite } from "@inmagik/react-crud"
import { FileDigitale, HistoricalInfo } from "../types"
import { API_URL } from "../constants"

export function useFilesDigitaliList(params: Record<string, string> = {}) {
  return useList<FileDigitale>(`${API_URL}/files-digitali`, {
    query: params,
  })
}

export function useFileDigitale(id: number | undefined | string) {
  return useDetail<FileDigitale>(`${API_URL}/files-digitali`, id?.toString())
}

export function useFileDigitaleCreate() {
  return useCreate<FileDigitale>(`${API_URL}/files-digitali`)
}

export function useFileDigitaleUpdate() {
  return usePartialUpdate<FileDigitale>(`${API_URL}/files-digitali`)
}

export function useFileDigitaleDelete() {
  return useDelete<FileDigitale>(`${API_URL}/files-digitali`)
}

export function useFileDigitaleHistory(id: number | string) {
  return useListInfinite<HistoricalInfo>(`${API_URL}/files-digitali/${id}/history`)
}
